(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/orders.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/orders.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  Fragment = _React.Fragment;
const ButtonRow = svs.ticket_partner.sharedComponents.buttonRow.ButtonRow;
const Order = svs.ticket_partner.myOrders.components.Order;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.constants.TEXTS,
  NO_ORDERS = _svs$ticket_partner$m.NO_ORDERS,
  SHOW_MORE = _svs$ticket_partner$m.SHOW_MORE;
const dataFetch = svs.ticket_partner.services.dataFetch;
const ORDER_INCREMENT = 2;
const Orders = () => {
  var _data$response;
  const _useState = useState(ORDER_INCREMENT),
    _useState2 = _slicedToArray(_useState, 2),
    ordersDisplayed = _useState2[0],
    setOrdersDisplayed = _useState2[1];
  const data = dataFetch({
    method: 'GET',
    path: '/ticket/1/triss/orders'
  });
  const sortedOrders = (data === null || data === void 0 || (_data$response = data.response) === null || _data$response === void 0 || (_data$response = _data$response.orders) === null || _data$response === void 0 ? void 0 : _data$response.sort((a, b) => new Date(b.ordered) - new Date(a.ordered))) || [];
  const showingOrdersText = "Visar ".concat(Math.min(ordersDisplayed, sortedOrders.length), " av ").concat(sortedOrders.length);
  return React.createElement(Fragment, null, sortedOrders.length === 0 && React.createElement("div", {
    className: "padding-2"
  }, NO_ORDERS), (sortedOrders === null || sortedOrders === void 0 ? void 0 : sortedOrders.length) && React.createElement(Fragment, null, sortedOrders.slice(0, ordersDisplayed).map((order, i) => React.createElement(Order, _extends({
    key: order.orderId || _.uniqueId(i)
  }, order))), React.createElement("div", {
    className: "u-text-center"
  }, React.createElement("p", null, showingOrdersText))), (sortedOrders === null || sortedOrders === void 0 ? void 0 : sortedOrders.length) > ordersDisplayed && React.createElement(ButtonRow, {
    buttons: [{
      'data-testid': 'show-more-button',
      label: SHOW_MORE,
      key: 'show-more-button',
      inverted: true,
      onClick: e => {
        e.preventDefault();
        setOrdersDisplayed(ordersDisplayed + ORDER_INCREMENT);
      }
    }],
    centerButton: true
  }));
};
svs.ticket_partner.myOrders.components.Orders = Orders;

 })(window);